// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file pb/serverrpc/v1/rpc.proto (package pb.serverrpc.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pb/serverrpc/v1/rpc.proto.
 */
export const file_pb_serverrpc_v1_rpc: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * RoomInfo is information about a room.
 *
 * @generated from message pb.serverrpc.v1.RoomInfo
 */
export type RoomInfo = Message<"pb.serverrpc.v1.RoomInfo"> & {
  /**
   * The room's name.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The number of online users in the room.
   *
   * @generated from field: uint32 online_user_count = 2;
   */
  onlineUserCount: number;
};

/**
 * Describes the message pb.serverrpc.v1.RoomInfo.
 * Use `create(RoomInfoSchema)` to create a new message.
 */
export const RoomInfoSchema: GenMessage<RoomInfo> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 0);

/**
 * OnlineUserInfo is information about an online user.
 *
 * @generated from message pb.serverrpc.v1.OnlineUserInfo
 */
export type OnlineUserInfo = Message<"pb.serverrpc.v1.OnlineUserInfo"> & {
  /**
   * The user's username.
   *
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message pb.serverrpc.v1.OnlineUserInfo.
 * Use `create(OnlineUserInfoSchema)` to create a new message.
 */
export const OnlineUserInfoSchema: GenMessage<OnlineUserInfo> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 1);

/**
 * AccountInfo is information about an account.
 *
 * @generated from message pb.serverrpc.v1.AccountInfo
 */
export type AccountInfo = Message<"pb.serverrpc.v1.AccountInfo"> & {
  /**
   * The account's username.
   *
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message pb.serverrpc.v1.AccountInfo.
 * Use `create(AccountInfoSchema)` to create a new message.
 */
export const AccountInfoSchema: GenMessage<AccountInfo> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 2);

/**
 * @generated from message pb.serverrpc.v1.GetRoomsRequest
 */
export type GetRoomsRequest = Message<"pb.serverrpc.v1.GetRoomsRequest"> & {
};

/**
 * Describes the message pb.serverrpc.v1.GetRoomsRequest.
 * Use `create(GetRoomsRequestSchema)` to create a new message.
 */
export const GetRoomsRequestSchema: GenMessage<GetRoomsRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 3);

/**
 * @generated from message pb.serverrpc.v1.GetRoomsResponse
 */
export type GetRoomsResponse = Message<"pb.serverrpc.v1.GetRoomsResponse"> & {
  /**
   * All the rooms in the server.
   *
   * @generated from field: repeated pb.serverrpc.v1.RoomInfo rooms = 1;
   */
  rooms: RoomInfo[];
};

/**
 * Describes the message pb.serverrpc.v1.GetRoomsResponse.
 * Use `create(GetRoomsResponseSchema)` to create a new message.
 */
export const GetRoomsResponseSchema: GenMessage<GetRoomsResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 4);

/**
 * @generated from message pb.serverrpc.v1.GetRoomInfoRequest
 */
export type GetRoomInfoRequest = Message<"pb.serverrpc.v1.GetRoomInfoRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message pb.serverrpc.v1.GetRoomInfoRequest.
 * Use `create(GetRoomInfoRequestSchema)` to create a new message.
 */
export const GetRoomInfoRequestSchema: GenMessage<GetRoomInfoRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 5);

/**
 * @generated from message pb.serverrpc.v1.GetRoomInfoResponse
 */
export type GetRoomInfoResponse = Message<"pb.serverrpc.v1.GetRoomInfoResponse"> & {
  /**
   * Information about the room..
   *
   * @generated from field: pb.serverrpc.v1.RoomInfo room = 1;
   */
  room?: RoomInfo;
};

/**
 * Describes the message pb.serverrpc.v1.GetRoomInfoResponse.
 * Use `create(GetRoomInfoResponseSchema)` to create a new message.
 */
export const GetRoomInfoResponseSchema: GenMessage<GetRoomInfoResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 6);

/**
 * @generated from message pb.serverrpc.v1.GetOnlineUsersRequest
 */
export type GetOnlineUsersRequest = Message<"pb.serverrpc.v1.GetOnlineUsersRequest"> & {
  /**
   * The room to query.
   *
   * @generated from field: string room = 1;
   */
  room: string;
};

/**
 * Describes the message pb.serverrpc.v1.GetOnlineUsersRequest.
 * Use `create(GetOnlineUsersRequestSchema)` to create a new message.
 */
export const GetOnlineUsersRequestSchema: GenMessage<GetOnlineUsersRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 7);

/**
 * @generated from message pb.serverrpc.v1.GetOnlineUsersResponse
 */
export type GetOnlineUsersResponse = Message<"pb.serverrpc.v1.GetOnlineUsersResponse"> & {
  /**
   * @generated from field: repeated pb.serverrpc.v1.OnlineUserInfo users = 1;
   */
  users: OnlineUserInfo[];
};

/**
 * Describes the message pb.serverrpc.v1.GetOnlineUsersResponse.
 * Use `create(GetOnlineUsersResponseSchema)` to create a new message.
 */
export const GetOnlineUsersResponseSchema: GenMessage<GetOnlineUsersResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 8);

/**
 * @generated from message pb.serverrpc.v1.GetOnlineUserInfoRequest
 */
export type GetOnlineUserInfoRequest = Message<"pb.serverrpc.v1.GetOnlineUserInfoRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string room = 1;
   */
  room: string;

  /**
   * The user's username.
   *
   * @generated from field: string username = 2;
   */
  username: string;
};

/**
 * Describes the message pb.serverrpc.v1.GetOnlineUserInfoRequest.
 * Use `create(GetOnlineUserInfoRequestSchema)` to create a new message.
 */
export const GetOnlineUserInfoRequestSchema: GenMessage<GetOnlineUserInfoRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 9);

/**
 * @generated from message pb.serverrpc.v1.GetOnlineUserInfoResponse
 */
export type GetOnlineUserInfoResponse = Message<"pb.serverrpc.v1.GetOnlineUserInfoResponse"> & {
  /**
   * Information about the online user.
   *
   * @generated from field: pb.serverrpc.v1.OnlineUserInfo user = 1;
   */
  user?: OnlineUserInfo;
};

/**
 * Describes the message pb.serverrpc.v1.GetOnlineUserInfoResponse.
 * Use `create(GetOnlineUserInfoResponseSchema)` to create a new message.
 */
export const GetOnlineUserInfoResponseSchema: GenMessage<GetOnlineUserInfoResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 10);

/**
 * @generated from message pb.serverrpc.v1.GetAccountsRequest
 */
export type GetAccountsRequest = Message<"pb.serverrpc.v1.GetAccountsRequest"> & {
  /**
   * The room to query.
   *
   * @generated from field: string room = 1;
   */
  room: string;
};

/**
 * Describes the message pb.serverrpc.v1.GetAccountsRequest.
 * Use `create(GetAccountsRequestSchema)` to create a new message.
 */
export const GetAccountsRequestSchema: GenMessage<GetAccountsRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 11);

/**
 * @generated from message pb.serverrpc.v1.GetAccountsResponse
 */
export type GetAccountsResponse = Message<"pb.serverrpc.v1.GetAccountsResponse"> & {
  /**
   * All accounts in the room.
   *
   * @generated from field: repeated pb.serverrpc.v1.AccountInfo accounts = 1;
   */
  accounts: AccountInfo[];
};

/**
 * Describes the message pb.serverrpc.v1.GetAccountsResponse.
 * Use `create(GetAccountsResponseSchema)` to create a new message.
 */
export const GetAccountsResponseSchema: GenMessage<GetAccountsResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 12);

/**
 * @generated from message pb.serverrpc.v1.CreateRoomRequest
 */
export type CreateRoomRequest = Message<"pb.serverrpc.v1.CreateRoomRequest"> & {
  /**
   * The new room's name.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message pb.serverrpc.v1.CreateRoomRequest.
 * Use `create(CreateRoomRequestSchema)` to create a new message.
 */
export const CreateRoomRequestSchema: GenMessage<CreateRoomRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 13);

/**
 * @generated from message pb.serverrpc.v1.CreateRoomResponse
 */
export type CreateRoomResponse = Message<"pb.serverrpc.v1.CreateRoomResponse"> & {
  /**
   * Information about the newly created room.
   *
   * @generated from field: pb.serverrpc.v1.RoomInfo room = 1;
   */
  room?: RoomInfo;
};

/**
 * Describes the message pb.serverrpc.v1.CreateRoomResponse.
 * Use `create(CreateRoomResponseSchema)` to create a new message.
 */
export const CreateRoomResponseSchema: GenMessage<CreateRoomResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 14);

/**
 * @generated from message pb.serverrpc.v1.DeleteRoomRequest
 */
export type DeleteRoomRequest = Message<"pb.serverrpc.v1.DeleteRoomRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message pb.serverrpc.v1.DeleteRoomRequest.
 * Use `create(DeleteRoomRequestSchema)` to create a new message.
 */
export const DeleteRoomRequestSchema: GenMessage<DeleteRoomRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 15);

/**
 * @generated from message pb.serverrpc.v1.DeleteRoomResponse
 */
export type DeleteRoomResponse = Message<"pb.serverrpc.v1.DeleteRoomResponse"> & {
};

/**
 * Describes the message pb.serverrpc.v1.DeleteRoomResponse.
 * Use `create(DeleteRoomResponseSchema)` to create a new message.
 */
export const DeleteRoomResponseSchema: GenMessage<DeleteRoomResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 16);

/**
 * @generated from message pb.serverrpc.v1.CreateAccountRequest
 */
export type CreateAccountRequest = Message<"pb.serverrpc.v1.CreateAccountRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string room = 1;
   */
  room: string;

  /**
   * The new account's username.
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * The new account's password, or empty to generate one.
   *
   * @generated from field: string password = 3;
   */
  password: string;
};

/**
 * Describes the message pb.serverrpc.v1.CreateAccountRequest.
 * Use `create(CreateAccountRequestSchema)` to create a new message.
 */
export const CreateAccountRequestSchema: GenMessage<CreateAccountRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 17);

/**
 * @generated from message pb.serverrpc.v1.CreateAccountResponse
 */
export type CreateAccountResponse = Message<"pb.serverrpc.v1.CreateAccountResponse"> & {
  /**
   * The generated password, if applicable.
   *
   * @generated from field: optional string generated_password = 1;
   */
  generatedPassword?: string;
};

/**
 * Describes the message pb.serverrpc.v1.CreateAccountResponse.
 * Use `create(CreateAccountResponseSchema)` to create a new message.
 */
export const CreateAccountResponseSchema: GenMessage<CreateAccountResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 18);

/**
 * @generated from message pb.serverrpc.v1.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"pb.serverrpc.v1.DeleteAccountRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string room = 1;
   */
  room: string;

  /**
   * The account's username.
   *
   * @generated from field: string username = 2;
   */
  username: string;
};

/**
 * Describes the message pb.serverrpc.v1.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 19);

/**
 * @generated from message pb.serverrpc.v1.DeleteAccountResponse
 */
export type DeleteAccountResponse = Message<"pb.serverrpc.v1.DeleteAccountResponse"> & {
};

/**
 * Describes the message pb.serverrpc.v1.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema: GenMessage<DeleteAccountResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 20);

/**
 * @generated from message pb.serverrpc.v1.UpdateAccountPasswordRequest
 */
export type UpdateAccountPasswordRequest = Message<"pb.serverrpc.v1.UpdateAccountPasswordRequest"> & {
  /**
   * The room's name.
   *
   * @generated from field: string room = 1;
   */
  room: string;

  /**
   * The account's username.
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * The account's new password, or empty to generate one.
   *
   * @generated from field: string password = 3;
   */
  password: string;
};

/**
 * Describes the message pb.serverrpc.v1.UpdateAccountPasswordRequest.
 * Use `create(UpdateAccountPasswordRequestSchema)` to create a new message.
 */
export const UpdateAccountPasswordRequestSchema: GenMessage<UpdateAccountPasswordRequest> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 21);

/**
 * @generated from message pb.serverrpc.v1.UpdateAccountPasswordResponse
 */
export type UpdateAccountPasswordResponse = Message<"pb.serverrpc.v1.UpdateAccountPasswordResponse"> & {
  /**
   * The generated password, if applicable.
   *
   * @generated from field: optional string generated_password = 1;
   */
  generatedPassword?: string;
};

/**
 * Describes the message pb.serverrpc.v1.UpdateAccountPasswordResponse.
 * Use `create(UpdateAccountPasswordResponseSchema)` to create a new message.
 */
export const UpdateAccountPasswordResponseSchema: GenMessage<UpdateAccountPasswordResponse> = /*@__PURE__*/
  messageDesc(file_pb_serverrpc_v1_rpc, 22);

/**
 * ServerRpcService provides an RPC interface to a running FriendNet server.
 * It can query state and perform administrative tasks.
 *
 * If authorization is required but not provided, returns status code UNAUTHENTICATED.
 * If authorization is invalid, returns PERMISSION_DENIED status code.
 *
 * @generated from service pb.serverrpc.v1.ServerRpcService
 */
export const ServerRpcService: GenService<{
  /**
   * GetRooms returns a list of all rooms in the server.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.GetRooms
   */
  getRooms: {
    methodKind: "unary";
    input: typeof GetRoomsRequestSchema;
    output: typeof GetRoomsResponseSchema;
  },
  /**
   * GetRoomInfo returns information about a room.
   * Returns status code NOT_FOUND if no such room exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.GetRoomInfo
   */
  getRoomInfo: {
    methodKind: "unary";
    input: typeof GetRoomInfoRequestSchema;
    output: typeof GetRoomInfoResponseSchema;
  },
  /**
   * GetOnlineUsers returns a list of online users in a room.
   * The response is paginated and may return zero or more responses.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.GetOnlineUsers
   */
  getOnlineUsers: {
    methodKind: "server_streaming";
    input: typeof GetOnlineUsersRequestSchema;
    output: typeof GetOnlineUsersResponseSchema;
  },
  /**
   * GetOnlineUserInfo returns information about an online user.
   * Returns status code NOT_FOUND if the user is not online or does not exist.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.GetOnlineUserInfo
   */
  getOnlineUserInfo: {
    methodKind: "unary";
    input: typeof GetOnlineUserInfoRequestSchema;
    output: typeof GetOnlineUserInfoResponseSchema;
  },
  /**
   * GetAccounts returns all accounts in a room.
   * Returns status code NOT_FOUND if no such room exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.GetAccounts
   */
  getAccounts: {
    methodKind: "unary";
    input: typeof GetAccountsRequestSchema;
    output: typeof GetAccountsResponseSchema;
  },
  /**
   * CreateRoom creates a new room.
   * Returns status code ALREADY_EXISTS if a room with the same name already exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.CreateRoom
   */
  createRoom: {
    methodKind: "unary";
    input: typeof CreateRoomRequestSchema;
    output: typeof CreateRoomResponseSchema;
  },
  /**
   * DeleteRoom deletes an existing room.
   * Any connected users are disconnected before deletion.
   * Returns status code NOT_FOUND if no such room exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.DeleteRoom
   */
  deleteRoom: {
    methodKind: "unary";
    input: typeof DeleteRoomRequestSchema;
    output: typeof DeleteRoomResponseSchema;
  },
  /**
   * CreateAccount creates a new account in a room.
   * It can generate a password if none is given.
   * Returns status code NOT_FOUND if no such room exists.
   * Returns status code ALREADY_EXISTS if an account with the same username already exists in the room.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.CreateAccount
   */
  createAccount: {
    methodKind: "unary";
    input: typeof CreateAccountRequestSchema;
    output: typeof CreateAccountResponseSchema;
  },
  /**
   * DeleteAccount deletes an existing account in a room.
   * Returns status code NOT_FOUND if no such room exists.
   * Returns status code NOT_FOUND if no such account exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof DeleteAccountResponseSchema;
  },
  /**
   * UpdateAccountPassword updates a user's password.
   * It can either update a user's password to a provided string, or generate one.
   * Returns status code NOT_FOUND if no such room exists.
   * Returns status code NOT_FOUND if no such account exists.
   *
   * @generated from rpc pb.serverrpc.v1.ServerRpcService.UpdateAccountPassword
   */
  updateAccountPassword: {
    methodKind: "unary";
    input: typeof UpdateAccountPasswordRequestSchema;
    output: typeof UpdateAccountPasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pb_serverrpc_v1_rpc, 0);

